import { type IUser } from 'entities/Users'
import { escapeHtml } from 'entities/Message/lib/escapeHtml'

export const truncateBeforeTag = (text: string, limit: number): string => {
  const sliced = text.slice(0, limit)
  const lastOpen = sliced.lastIndexOf('{')
  if (lastOpen !== -1 && sliced.indexOf('}', lastOpen) === -1) {
    return sliced.slice(0, lastOpen)
  }
  return sliced
}

export const replaceMentionTagsWithSpans = (html: string, usersMap: Map<number, IUser>): string =>
  html
    .replace(/\{tag:user:(\d+)\}/g, (_, id) => {
      const user = usersMap.get(Number(id))
      return `<span data-readonly contentEditable="false" data-template="{tag:user:${id}}" class='mentions-wrap'>${escapeHtml(
        user?.full_name || ''
      )}</span>`
    })
    .replace(
      /\{tag:inbox\}/g,
      '<span data-readonly contentEditable="false" data-template="{tag:inbox}" class=\'mentions-wrap\'>@inbox</span>'
    )

export const noteTagsToPlainText = (text: string, usersMap: Map<number, IUser>): string =>
  text
    .replace(/\{tag:user:(\d+)\}/g, (_, id) => {
      const user = usersMap.get(Number(id))
      return `@${user?.full_name || ''}`
    })
    .replace(/\{tag:inbox\}/g, '@inbox')

export const parseNoteBody = (body: string, users: Map<number, IUser>) => {
  body = body.replaceAll(/\{tag:(\S+)\}/g, (value, data) => {
    const [type, id] = data.split(':')
    const user = users.get(Number(id))

    if (type === 'inbox') {
      return '<a class="mention" href="#">@inbox</a>'
    }

    return `<a class="mention" href="#">@${user?.full_name || ''}</a>`
  })

  return body
}

export const parseMentionsTemplate = (body: string, users: Map<number, IUser>) => {
  body = body.replaceAll('@inbox', '{tag:inbox}')

  const validUsers = Array.from(users.values())
    .filter((user) => user.full_name && user.full_name.trim() !== '')
    .sort((a, b) => b.full_name!.length - a.full_name!.length)

  validUsers.forEach((user) => {
    body = body.replaceAll(`@${user.full_name}`, `{tag:user:${user.id}}`)
  })

  return body
}
